import { put, takeLatest, select } from 'redux-saga/effects';
import { fetchDashboardTasks, appNotify, setDashboardTasks, setMyTasksIsLoading } from 'store/actions';
import { postWithToken } from 'api/network';
import { dashboardFilterSelector } from 'store/selectors';

export function* getDashboardTasksSaga() {
  yield takeLatest(fetchDashboardTasks, function* ({ payload }) {
    try {
      yield put(setMyTasksIsLoading(true));

      var filter = yield select(dashboardFilterSelector);
      const data = {
        channels: payload.channels,
        userIds: payload.selectedUsers,
        loadOptions: {
          select: ["ChannelText","UnderwriteStatus"],
          remoteSelect: true,
          filter: filter,
          group: [
            { "selector": "ChannelText", "desc": false, "isExpanded": false },
            { "selector": "UnderwriteStatus", "desc": false, "isExpanded": false }
          ]
        }
      }

      const dashboardTasks = [];
      const url = `/api/dashboard/getDashboardTasks`;
      yield postWithToken(url, data )
        .then(response => response.json())
        .then((data) => {
          if(data.data?.length > 0){
            data.data.forEach((group) => {
              group.items.forEach((item) => {
                const task = {channel: group.key, dashboardTaskType: item.key ?? "Incomplete", count: item.count};
                dashboardTasks.push(task);
              }) 
            })
          }
        });

      console.log(`${payload.channels} (${payload.selectedUsers.join(', ')} users) tasks: `, dashboardTasks);

      yield put(setDashboardTasks({dashboardTasks}));
      yield put(setMyTasksIsLoading(false));
    } catch (error) {
      yield put(appNotify(`Failed to fetch dashboard tasks: ${error.message}`, 'error'));
      yield put(setMyTasksIsLoading(false));
    }
  });
}
